import { useTranslation, Trans } from "react-i18next";

/**
 * Overview help page component for Sheet Agent.
 * Displays information about what Sheet Agent is.
 *
 * @component
 */
function HelpPageOverview() {
  const { t } = useTranslation("modals");

  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <h2 className="text-xl font-semibold">{t("sheetagent.help.overview.title")}</h2>
        <p className="text-sm text-muted-foreground leading-relaxed">
          {t("sheetagent.help.overview.description")}
        </p>
      </div>

      <div className="space-y-3">
        <h3 className="text-lg font-medium">{t("sheetagent.help.overview.howitworkstitle")}</h3>
        <div className="space-y-2 text-sm text-muted-foreground">
          <div className="flex gap-2">
            <span className="font-medium text-foreground">1.</span>
            <p>{t("sheetagent.help.overview.step1")}</p>
          </div>
          <div className="flex gap-2">
            <span className="font-medium text-foreground">2.</span>
            <p>{t("sheetagent.help.overview.step2")}</p>
          </div>
          <div className="flex gap-2">
            <span className="font-medium text-foreground">3.</span>
            <p>{t("sheetagent.help.overview.step3")}</p>
          </div>
          <div className="flex gap-2">
            <span className="font-medium text-foreground">4.</span>
            <p>
              <Trans
                i18nKey="sheetagent.help.overview.step4"
                ns="modals"
                components={{
                  strong: <strong className="text-foreground" />,
                }}
              />
            </p>
          </div>
        </div>
      </div>

      <div className="p-4 bg-blue-50 dark:bg-blue-950/20 border border-blue-200 dark:border-blue-800 rounded-md">
        <p className="text-sm text-blue-900 dark:text-blue-100">
          <strong className="font-medium">{t("sheetagent.help.overview.notetitle")}</strong>{" "}
          {t("sheetagent.help.overview.notecontent")}
        </p>
      </div>
    </div>
  );
}

export default HelpPageOverview;
